import loadingIcon from "assets/img/icons/empty-predictions.svg";

const CraftBlockPredictionCombineLoader = () => {
  return (
    <img
      src={loadingIcon}
      alt=""
      className="card-details__craft-empty-loader"
    />
  )
}

export default CraftBlockPredictionCombineLoader;
